import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=084c245c&scoped=true&name=page-not-found"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=084c245c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c245c",
  null
  
)

export default component.exports